var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopUpGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 119,
    viewBox: "0 0 141 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.143 118.218C130.36 110.295 119.61 102.344 110.381 96.8529C101.185 91.3341 93.5113 88.2741 81.7248 86.8261C69.9383 85.4054 53.9748 85.624 47.272 79.2035C40.5693 72.7831 43.0949 59.6964 36.2627 51.0903C29.4304 42.4841 13.2402 38.3587 5.82508 30.5995C-1.62242 22.813 -0.294829 11.4202 1.03277 0H141.143V118.218Z",
    fill: "#60FF52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopUpGreen);
export default __webpack_public_path__ + "static/media/PopUpGreen.f5022ada78bcf381d0db4591283555da.svg";
export { ForwardRef as ReactComponent };